export default __webpack_public_path__ + "static/media/frame2.3b7f15e2.webp";